import styles from './ButtonWithSpinner.module.css';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';

export const ButtonWithSpinner = ({
    className,
    isLoading = false,
    children,
    type = 'button',
    size = 'large',
    onClick,
}) => (
    <div className={styles.buttonWrapper}>
        <Button
            type={type}
            size={size}
            className={classnames(className, { [styles.loadingButton]: isLoading })}
            fullWidth
            onClick={onClick}
        >
            {children}
        </Button>
        {
            isLoading && (
                <CircularProgress
                    size={24}
                    className={styles.spinner}
                />
            )}
    </div>
);
